import React, { Component } from "react";
import styles from "./about-clients.module.scss";
import theme from "../styles/theme.module.scss";

function AboutIntro(props) {
  return (
    <div
      className={`${styles.root} ${theme.gdcont} ${theme.gmcont} ${theme.mT7} ${theme.pB3} ${theme.borderBottom}`}
    >
      <h2 className={`${theme.h5_founders} ${theme.gdmain} ${theme.gmmain} ${theme.mB5}`}>
        Select Clients
      </h2>
      <ul className={`${styles.list} ${theme.gdmain} ${theme.gmmain}`}>
        {props.clientsList &&
          props.clientsList.map((node, index) => (
            <li className={`${styles.listItem}`} key={index}>
              {node}
            </li>
          ))}
      </ul>
    </div>
  );
}

export default AboutIntro;
